module.exports = __webpack_public_path__ + "img/twitter-badge.bd1252eb.png";